import { BundleService } from "src/app/Services/bundleservice.service";
import { DialogExampleComponent } from "./../../dialog-example/dialog-example.component";
import { UserserviceService } from "./../../Services/userservice.service";
import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { FlowServiceService } from "src/app/Services/flow-service.service";

import { Router, NavigationExtras, NavigationEnd, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { MatTabChangeEvent } from "@angular/material/tabs";
// import * as firebase from "firebase";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { MatDialog } from "@angular/material/dialog";
import { ImageDialogComponent } from "../image-dialog/image-dialog.component";
import { Location } from "@angular/common";
import { BundledialogComponent } from "../bundledialog/bundledialog.component";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { UserProfileQrCodeComponent } from "../user-profile-qr-code/user-profile-qr-code.component";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, map } from "rxjs/operators";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { getConsultationDashboardPath } from "src/app/utils/consultation-notification-nav.util";
import { FlowQueryService } from "src/app/shared/flowquery.helper";
import { DeleteUserDialogComponent } from "../delete-user-dialog/delete-user-dialog.component";
import { log } from "console";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { TranslationService } from "src/app/Services/translation.service";
import {
  getFeedPosterUrl,
  trackFeedItem,
} from "src/app/utils/feed-thumbnail.util";
import {
  getAssignedPlanId,
  hasAssignedContentPlan,
} from "src/app/shared/utils/plan.util";
import { SubscriptionUsageDialogComponent } from "../subscription-usage-dialog/subscription-usage-dialog.component";
import { getTrialDaysLeft, isTrialActive } from "src/app/shared/utils/trial.util";
import { OrgContextService } from "src/app/Services/org-context.service";
import { BundleEditorLauncherService } from "src/app/Services/bundle-editor-launcher.service";
import { DeleteBundleDialogComponent } from "../delete-bundle-dialog/delete-bundle-dialog.component";
import { ToastrService } from "ngx-toastr";
import { FrontlineGlossary } from "src/app/shared/constants/frontline-glossary";

export type ProfileTabId =
  | "guides"
  | "guidePacks"
  | "draft"
  | "saved"
  | "purchased"
  | "builds"
  | "applications"
  | "teams";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  animal: "panda" | "unicorn" | "lion";

  userDisplayName: any;
  userDisplayEmail: any;
  carouselOptions: any;
  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  profilePicture: string;
  planId: string = "standard";
  planDisplayName: string = "Standard";
  showPlanLabel: boolean = false;
  private openPlanUsageOnLoad = false;

  isthereAnyFlows: boolean;

  flows: any = [];
  savedFlows: any = [];
  userData: any;
  approvedFlows: any = [];
  draftFlows: any = [];
  profileUser: any = [];
  purchasedFlows: any = [];
  bundles: any = [];
  userBuilds: any = [];

  followerCount: number;
  followingCount: number;

  currentImage: any;
  previousIndex: any;
  showImg = false;
  arrow = false;
  itemCount = 0;
  scrHeight: any;
  scrWidth: any;
  SlideOptions: any;
  showDefaultImage: boolean;
  isMobileView: boolean;
  isSearchOpen: boolean = false;
  searchInput: string = "";
  isSearchActive: boolean = false;
  searchResults: any = [];
  categories: any;
  showNotificationCount: boolean;
  notificationCount: number;
  notificationtitle: any;
  notificationbody: any;
  notificationsarray: any = [];
  notificationscount: number;
  account_circle: any;

  ShowAboutYou: boolean;
  ShowEmail: boolean;
  ShowName: boolean;
  ShowWebsite: boolean;
  ShowPhone: boolean;

  FlowCount: number = 0;
  Bundlecount: number = 0;
  private contentCountsRequestId = 0;
  Draftcount: number = 0;
  Savedcount: number = 0;
  Purchasedcount: number = 0;
  ReviewsCount: number = 0;
  FollowingCount: number;
  FollowersCount: number;

  tabIndex: any;
  _steps: any = [];

  tempFlows: any = [];
  istempFlows: any = [];
  itistempFlows: any = [];
  allTempFlows: any[] = [];
  allTempBundles: any[] = [];
  allDraftTempFlows: any[] = [];
  allSavedTempFlows: any[] = [];
  allPurchasedTempFlows: any[] = [];
  allUserBuilds: any[] = [];
  getNotificationUrl: string;
  getFollowersUrl: string;
  itemsRequired: any[];
  savedFlowslength: number;
  draftFlowslength: number;
  approvedFlowslength: number;

  infiniteScrollCount: number;
  isthereAnySavedFlows: boolean;
  isthereAnyDraftFlows: boolean;
  isthereAnyPurchasedFlows: boolean;
  isthereAnyBuilds: boolean;
  BuildsCount: number = 0;

  noApprovedFlows: boolean;
  noDraftFlows: boolean;
  noSavedFlows: boolean;
  noPurchasedFlows: boolean;
  noBundles: boolean;
  isLoadingMore: boolean = false;

  noMoreApprovedFlows: boolean = false;
  noMoreBundles: boolean = false;
  noMoreDraftFlows: boolean = false;
  noMoreSavedFlows: boolean = false;
  noMorePurchasedFlows: boolean = false;

  private readonly PAGE_SIZE = 15;
  /** Cap auto-pagination when org-scope filtering skips whole pages. */
  private readonly MAX_SCOPE_SKIP_PAGES = 20;
  private approvedScopeSkipPages = 0;
  private draftScopeSkipPages = 0;
  private bundleScopeSkipPages = 0;
  isInitialDataLoading: boolean = true;
  isInitialProfileDataLoading: boolean = true;
  isInitialContentLoading: boolean = true;

  selector: string = ".example-container";
  userEmail: any;
  tempBundles: any = [];
  CategoryName: string;
  isItBundle: boolean;
  isthereAnyBundles: boolean;
  flowPurchased: boolean;

  activeTabIndex: number;
  add_circle_outlinebgColor: string;
  add_circle_outlineColor: string;
  add_circle_outlineSize: string;
  GiftedFund: any;
  filteredBlogs: any;
  // Track if tabs have already loaded once to avoid reloading/skeleton on tab switch
  hasLoadedApproved: boolean = false;
  hasLoadedBundles: boolean = false;
  getFeedPosterUrl = getFeedPosterUrl;
  trackFlowCard = trackFeedItem;
  // Store scroll positions for each tab
  tabScrollPositions: { [key: number]: number } = {};
  hasLoadedDraft: boolean = false;
  hasLoadedSaved: boolean = false;
  hasLoadedPurchased: boolean = false;
  hasLoadedBuilds: boolean = false;
  hasLoadedReviews: boolean = false;
  isthereAnyReviews: boolean = false;
  userReviews: any[] = [];
  noReviews: boolean = false;

  readonly glossary = FrontlineGlossary;
  showCreatorLibraryTabs = true;
  showOrgMembershipTabs = false;
  showApplicationsTab = false;
  /** True when account type is Public (not an active organization). */
  isPublicAccountMode = true;
  private orgContextHandling = false;
  /** Tracks org scope used for the last library load so org switches reload lists. */
  private lastProfileOrgScopeId: string | null = null;
  visibleTabIds: ProfileTabId[] = [
    "guides",
    "guidePacks",
    "draft",
    "saved",
    "purchased",
    "builds",
  ];
  profileApplications: any[] = [];
  profileTeams: any[] = [];

  private hasInitializedNavigationRefresh: boolean = false;
  private orgContextSub: Subscription | null = null;

  constructor(
    private flowServiceService: FlowServiceService,
    private dataService: DataService,

    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userserviceService: UserserviceService,
    private eventEmitterService: EventEmitterService,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog,
    public location: Location,
    private bundleService: BundleService,
    private titleandmetaserviceService: TitleandmetaserviceService,
    private flowQueryService: FlowQueryService,
    public authModalService: AuthModalService,
    private translationService: TranslationService,
    public orgContextService: OrgContextService,
    private bundleEditorLauncher: BundleEditorLauncherService,
    private toastr: ToastrService
  ) {
    this.activeTabIndex = 0;
    this.titleandmetaserviceService.setTitle("User Profile");
    this.noflow = false;
    this.savedFlowslength = 0;
    this.approvedFlowslength = 0;
    this.draftFlowslength = 0;
    this.infiniteScrollCount = 100;
    this.getNotificationUrl = "v1/Notification/GetUserNotifications";
    this.tabIndex = localStorage.getItem("draftTabIndex");
  }

  getActiveTabId(): ProfileTabId {
    return (
      this.visibleTabIds[this.activeTabIndex] ||
      this.visibleTabIds[0] ||
      "saved"
    );
  }

  isActiveTab(id: ProfileTabId): boolean {
    return this.getActiveTabId() === id;
  }

  selectProfileApplication(app: any): void {
    const appId = app?.applicationId || app?.ApplicationId || null;
    if (!appId) {
      return;
    }
    this.orgContextService.setActiveApplication(appId);
    this.refreshProfileTeams();
    this.ref.detectChanges();
  }

  /** Prefer API full name (First + Last); fall back to admin email. */
  getMembershipAdminLabel(item: any): string {
    const display = (
      item?.adminDisplayName ||
      item?.AdminDisplayName ||
      ""
    ).trim();
    if (display) {
      return display;
    }
    return (item?.adminEmail || item?.AdminEmail || "").trim();
  }

  getApplicationTeamCount(app: any): number {
    const fromApi = app?.teamCount ?? app?.TeamCount;
    if (typeof fromApi === "number" && fromApi >= 0) {
      return fromApi;
    }
    const appId = app?.applicationId || app?.ApplicationId;
    if (!appId) {
      return 0;
    }
    return (this.orgContextService.snapshot.teams || []).filter(
      (t: any) => t.applicationId === appId
    ).length;
  }

  getTeamMemberCount(team: any): number {
    const fromApi = team?.memberCount ?? team?.MemberCount;
    if (typeof fromApi === "number" && fromApi >= 0) {
      return fromApi;
    }
    return 0;
  }

  getTeamApplicationName(team: any): string {
    const fromApi = (
      team?.applicationName ||
      team?.ApplicationName ||
      ""
    ).trim();
    if (fromApi) {
      return fromApi;
    }
    const appId = team?.applicationId || team?.ApplicationId;
    if (!appId) {
      return "";
    }
    const app = (this.orgContextService.snapshot.applications || []).find(
      (a: any) => a.applicationId === appId
    );
    return (app?.name || "").trim();
  }

  formatMembershipDate(value: string | Date | null | undefined): string {
    if (!value) {
      return "";
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return "";
    }
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  private rebuildVisibleTabs(): void {
    const snap = this.orgContextService.snapshot;
    const orgLoaded = !!snap.loaded;
    const inOrgMode = this.orgContextService.isOrganizationMode();
    this.isPublicAccountMode = !inOrgMode;

    let showCreator = true;
    let showOrgMembership = false;

    if (orgLoaded && inOrgMode) {
      const creator = this.orgContextService.canAccessCreatorChrome();
      showCreator = creator;
      showOrgMembership = !creator;
    } else {
      // Public account: always show the full public library tab set
      // (Guides, Guide Packs, Draft, Saved, Purchased, Builds).
      showCreator = true;
      showOrgMembership = false;
    }

    this.showCreatorLibraryTabs = showCreator;
    this.showOrgMembershipTabs = showOrgMembership;
    this.profileApplications = inOrgMode ? snap.applications || [] : [];
    this.showApplicationsTab =
      showOrgMembership && this.profileApplications.length > 1;
    this.refreshProfileTeams();

    if (showCreator && inOrgMode) {
      // Org creators: library tabs only — no public marketplace Purchased/Builds.
      this.visibleTabIds = ["guides", "guidePacks", "draft", "saved"];
    } else if (showCreator) {
      this.visibleTabIds = [
        "guides",
        "guidePacks",
        "draft",
        "saved",
        "purchased",
        "builds",
      ];
    } else if (showOrgMembership) {
      this.visibleTabIds = ["saved"];
      if (this.showApplicationsTab) {
        this.visibleTabIds.push("applications");
      }
      this.visibleTabIds.push("teams");
    } else {
      this.visibleTabIds = ["saved"];
    }

    if (
      this.activeTabIndex < 0 ||
      this.activeTabIndex >= this.visibleTabIds.length
    ) {
      this.activeTabIndex = 0;
      this.tabIndex = "0";
    }
  }

  /** Whether a flow/bundle belongs to the active account type (public vs org). */
  private itemMatchesAccountScope(item: any): boolean {
    if (!item) return false;
    const itemOrg =
      item.organizationId ||
      item.OrganizationId ||
      null;
    const hasOrg =
      !!itemOrg &&
      String(itemOrg).trim() !== "" &&
      String(itemOrg).toLowerCase() !== "none";

    if (this.orgContextService.isOrganizationMode()) {
      const activeOrg =
        this.orgContextService.snapshot.activeOrganization?.organizationId ||
        localStorage.getItem("activeOrganizationId");
      if (!activeOrg) return false;
      return hasOrg && String(itemOrg).toLowerCase() === String(activeOrg).toLowerCase();
    }

    // Public account: personal/public content only (no org stamp).
    return !hasOrg;
  }

  private getActiveOrgScopeId(): string | null {
    if (!this.orgContextService.isOrganizationMode()) {
      return null;
    }
    return (
      this.orgContextService.snapshot.activeOrganization?.organizationId ||
      localStorage.getItem("activeOrganizationId") ||
      null
    );
  }

  private resetLoadedTabFlags(): void {
    this.hasLoadedApproved = false;
    this.hasLoadedBundles = false;
    this.hasLoadedDraft = false;
    this.hasLoadedSaved = false;
    this.hasLoadedPurchased = false;
    this.hasLoadedBuilds = false;
    this.hasLoadedReviews = false;
  }

  private refreshProfileTeams(): void {
    if (!this.orgContextService.isOrganizationMode()) {
      this.profileTeams = [];
      return;
    }
    const snap = this.orgContextService.snapshot;
    const teams = snap.teams || [];
    const appId = snap.activeApplicationId;
    this.profileTeams = appId
      ? teams.filter((t: any) => t.applicationId === appId)
      : [...teams];
  }

  openImgDialog() {
    localStorage.removeItem("profilePicture");
    this.dialog.open(ImageDialogComponent, {
      data: {
        animal: "panda",
      },
    });
  }

  gotoUserQrCode() {
    localStorage.setItem("userprofileqrCode", "user-profile");
    const dialogRef = this.dialog.open(UserProfileQrCodeComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  ngOnInit() {
    this.isthereAnyFlows = true;
    this.isthereAnyDraftFlows = true;
    this.isthereAnySavedFlows = true;
    this.isInitialContentLoading = true;
    this.flowServiceService.setScrollTop();
    const width = window.innerWidth || document.body.clientWidth;
    this.eventEmitterService.setHomePageIconColorEvent("user");
    this.eventEmitterService.setUserProfileCreateIconClickedEvent("profile");
    localStorage.setItem("approvedPageIndex", "0");
    localStorage.setItem("draftPageIndex", "0");
    localStorage.setItem("savePageIndex", "0");
    localStorage.setItem("purchasePageIndex", "0");
    if (width <= 1200) {
      console.log(width);
      this.isMobileView = true;
      this.isSearchOpen = true;
    } else {
      this.isMobileView = false;
      this.isSearchOpen = false;
    }
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
      this.userEmail = this.userData.emailAddress;
    }
    this.flows = [];
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.refreshPlanLabel(this.userData);
    this.openPlanUsageOnLoad =
      this.activatedRoute.snapshot.queryParamMap.get("showPlan") === "1";
    this.tempBundles = [];
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
      this.userDisplayEmail = this.userData.emailAddress;
      this.email = this.userData.emailAddress;
      this.phone = this.userData.phoneNumber;
      this.info = this.userData.info;
      this.website = this.userData.website;
      this.uname = this.userData.userName;
      this.name = this.userData.firstName;
      this.followerCount = 0;
      this.followingCount = 0;
      this.rebuildVisibleTabs();
      this.lastProfileOrgScopeId = this.getActiveOrgScopeId();
      // draftTabIndex only applies when the Draft tab exists in creator layout
      if (
        this.showCreatorLibraryTabs &&
        this.tabIndex != null &&
        String(this.tabIndex) === "2"
      ) {
        this.activeTabIndex = this.visibleTabIds.indexOf("draft");
        if (this.activeTabIndex < 0) {
          this.activeTabIndex = 0;
        }
        this.tabIndex = String(this.activeTabIndex);
      } else {
        this.tabIndex = this.tabIndex ?? "0";
        this.syncActiveTabIndexFromTabBinding();
      }

      this.getProfileUser();
      this.loadTabContentForId(this.getActiveTabId(), false);

      this.orgContextSub = this.orgContextService
        .watch()
        .pipe(
          map((snap) => ({
            mode: snap.accountUsageMode,
            orgId: snap.activeOrganization?.organizationId || null,
            loaded: snap.loaded,
            appId: snap.activeApplicationId || null,
            teamId: snap.activeTeamId || null,
            membershipCount: (snap.memberships || []).length,
          })),
          distinctUntilChanged(
            (a, b) =>
              a.mode === b.mode &&
              a.orgId === b.orgId &&
              a.loaded === b.loaded &&
              a.appId === b.appId &&
              a.teamId === b.teamId &&
              a.membershipCount === b.membershipCount
          )
        )
        .subscribe(() => {
          if (this.orgContextHandling) {
            return;
          }
          this.orgContextHandling = true;
          try {
            const previousId = this.getActiveTabId();
            const prevCreator = this.showCreatorLibraryTabs;
            const prevTabs = this.visibleTabIds.join("|");
            const prevPublic = this.isPublicAccountMode;
            const prevOrgScopeId = this.lastProfileOrgScopeId;
            this.rebuildVisibleTabs();
            const activeOrgScopeId = this.getActiveOrgScopeId();
            const tabsChanged = this.visibleTabIds.join("|") !== prevTabs;
            const creatorChanged = prevCreator !== this.showCreatorLibraryTabs;
            const modeChanged = prevPublic !== this.isPublicAccountMode;
            const orgScopeChanged = prevOrgScopeId !== activeOrgScopeId;
            // Account type / org change: always reload lists for the active scope.
            if (modeChanged || tabsChanged || creatorChanged || orgScopeChanged) {
              this.lastProfileOrgScopeId = activeOrgScopeId;
              if (modeChanged || orgScopeChanged) {
                this.loadScopedContentCounts();
              }
              this.resetLoadedTabFlags();
              if (!this.visibleTabIds.includes(previousId)) {
                this.activeTabIndex = 0;
                this.tabIndex = "0";
              } else {
                this.activeTabIndex = this.visibleTabIds.indexOf(previousId);
                this.tabIndex = String(this.activeTabIndex);
              }
              this.loadTabContentForId(this.getActiveTabId(), true);
            } else if (!this.visibleTabIds.includes(previousId)) {
              this.activeTabIndex = 0;
              this.tabIndex = "0";
              this.resetLoadedTabFlags();
              this.loadTabContentForId(this.getActiveTabId(), true);
            } else {
              this.refreshProfileTeams();
            }
          } finally {
            this.orgContextHandling = false;
          }
        });

      this.scrollSubject.pipe(debounceTime(2000)).subscribe({
        next: (event) => {
          this.performScroll(event);
        },
        error: (error) => {
          console.error("Error in scroll subscription:", error);
        },
      });
    } else {
      this.isItBundle = false;
      this.router.navigate(["login"]);
    }

    // Ensure APIs are called whenever we (re)enter the user-profile page
    this.setupNavigationRefresh();

    this.eventEmitterService.setNotificationCompleted =
      this.eventEmitterService.setNotificationFunction.subscribe(
        (notificationModelArray: any) => {
          this.notificationsarray = [];
          this.showNotificationCount = true;
          const notifications = JSON.parse(notificationModelArray);
          notifications.forEach((element) => {
            this.notificationsarray.push(element.notification);
          });
          this.notificationscount = this.notificationsarray.length;
          this.ref.detectChanges();
        }
      );
  }

  flowClicked(flow) {
    localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.setItem("notificationflowId", null);
    localStorage.setItem("navigateTo", "user-profile");
    if (flow.type == "Bundle") {
      this.isItBundle = true;
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      this.isItBundle = false;
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  deleteDraftFlow(item: any, event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    if (!item?.rowKey) {
      return;
    }

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (!this.userData?.emailAddress) {
      return;
    }

    if (this.isBundleItem(item)) {
      localStorage.setItem("bundleIdToBeDeleted", `${item.rowKey}`);
      localStorage.setItem(
        "bundleData",
        JSON.stringify({ rowKey: item.rowKey, customerEmail: item.customerEmail || this.userData.emailAddress })
      );
      this.dialog
        .open(DeleteBundleDialogComponent, {
          panelClass: "confirmation-dialog",
          width: "420px",
          maxWidth: "95vw",
          autoFocus: false,
        })
        .afterClosed()
        .subscribe((deleted) => {
          if (deleted === true) this.removeDraftFlowFromLists(item.rowKey);
        });
      return;
    }

    const flowPayload = {
      rowKey: item.rowKey,
      CustomerEmail: item.customerEmail || this.userData.emailAddress,
      Title: item.title,
      Description: item.description,
      Url: item.url,
      Steps: [],
      Components: [],
    };

    localStorage.setItem("flow", JSON.stringify(flowPayload));

    const dialogRef = this.dialog.open(DialogExampleComponent, {
      panelClass: "dialoguebox",
      width: "480px",
      maxWidth: "95vw",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.deleted) {
        this.removeDraftFlowFromLists(item.rowKey);
      }
    });
  }

  private removeDraftFlowFromLists(rowKey: string): void {
    this.itistempFlows = this.itistempFlows.filter((f) => f.rowKey !== rowKey);
    this.allDraftTempFlows = this.allDraftTempFlows.filter(
      (f) => f.rowKey !== rowKey
    );
    this.draftFlows = [...this.itistempFlows];
    this.isthereAnyDraftFlows = this.itistempFlows.length > 0;
    if (this.Draftcount > 0) {
      this.Draftcount--;
    }
    this.noDraftFlows = this.itistempFlows.length > 0;
    this.ref.detectChanges();
  }

  isBundleItem(item: any): boolean {
    return (
      item?.isBundle === true ||
      item?.IsBundle === true ||
      String(item?.type || item?.Type || "").toLowerCase() === "bundle"
    );
  }

  /** Status badge for Draft-tab cards: "Draft", "In review" or "Changes requested". */
  draftStatusLabel(item: any): string {
    const approval = String(item?.approvalState || item?.ApprovalState || "");
    const status = String(item?.flowStatus || item?.FlowStatus || "");
    if (approval === "InReview" || status === "InReview") return "In review";
    if (approval === "Rejected") return "Changes requested";
    return "Draft";
  }

  draftStatusKey(item: any): string {
    const label = this.draftStatusLabel(item);
    return label === "In review" ? "in-review" : label === "Changes requested" ? "rejected" : "draft";
  }

  /** Approved by a reviewer but not yet published (shown in the Guides / Guide Packs tabs). */
  isApprovedNotPublished(item: any): boolean {
    const status = String(item?.flowStatus || item?.FlowStatus || item?.bundleStatus || item?.BundleStatus || "");
    return status === "ContentApproved";
  }

  draftflowClicked(flow) {
    if (this.isBundleItem(flow)) {
      const email = JSON.parse(localStorage.getItem("LoggedInUser") || "null")?.emailAddress || "";
      this.bundleEditorLauncher.openByRowKey(`${flow.rowKey || flow.RowKey}`, email).subscribe((opened) => {
        if (!opened) this.toastr.error("Couldn't open this guide pack. Please try again.");
      });
      return;
    }
    var flowCoverPage = {
      coverImage: flow.url,
      coverPosterPageURI: flow.videoThumbNailUrl || flow.VideoThumbNailUrl || "",
      rowKey: flow.rowKey,
      description: flow.description,
      title: flow.title,
      type: flow.type,
      fileName: flow.fileName,
      uniqueId: flow.uniqueId,
      duration: flow.duration,
      durationUnit: flow.durationUnit || 'Mins',
      price: flow.price,
      isPaid: flow.isPaid,
      customerEmail: flow.customerEmail,
      partitionKey: flow.customerEmail,
      searchKeyWords: flow.searchKeyWords,
      coverIsSafetyCritical: flow.CoverIsSafetyCritical || flow.coverIsSafetyCritical || false,
      coverSafetyInstructionsTitle: flow.CoverSafetyInstructionsTitle || flow.coverSafetyInstructionsTitle || "",
      coverSafetyInstructionsDescription: flow.CoverSafetyInstructionsDescription || flow.coverSafetyInstructionsDescription || "",
      isSponsored: flow.isSponsored || flow.IsSponsored || false,
      // Collaboration
      isCollaboration: flow.isCollaboration || flow.IsCollaboration || false,
      coAuthorEmail: flow.coAuthorEmail || flow.CoAuthorEmail || null,
      coAuthorEmails: flow.coAuthorEmails || flow.CoAuthorEmails || null,
      coAuthorUserName: flow.coAuthorUserName || flow.CoAuthorUserName || null,
      coAuthorProfilePicUrl: flow.coAuthorProfilePicUrl || flow.CoAuthorProfilePicUrl || null,
      collaborationValue: flow.collaborationValue || flow.CollaborationValue || null,
      collaborationStatus: flow.collaborationStatus || flow.CollaborationStatus || null,
    };

    console.log(flowCoverPage);

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    var email = "";

    if (this.userData != null) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      FlowId: flow.rowKey,
      userEmail: email,
    });

    this.flowServiceService.getFlowById(flowQueryModel).subscribe((data) => {
      if (data.flows != null) {
        localStorage.removeItem("flow");
        const coverWithAccess = {
          ...flowCoverPage,
          accessType: data.flows.accessType || data.flows.AccessType || "",
          restrictedAccessType:
            data.flows.restrictedAccessType || data.flows.RestrictedAccessType || "",
          isSearchHidden: data.flows.isSearchHidden ?? data.flows.IsSearchHidden,
          restrictedAccessFlows:
            data.flows.restrictedAccessFlows || data.flows.RestrictedAccessFlows || [],
          enforceNetwork: data.flows.enforceNetwork || data.flows.EnforceNetwork || false,
          enforceGeo: data.flows.enforceGeo || data.flows.EnforceGeo || false,
          enforceDevice: data.flows.enforceDevice || data.flows.EnforceDevice || false,
          enforceCompanyEmail:
            data.flows.enforceCompanyEmail || data.flows.EnforceCompanyEmail || false,
          allowedCidrs: data.flows.allowedCidrs || data.flows.AllowedCidrs || "",
          allowedEmailDomains:
            data.flows.allowedEmailDomains || data.flows.AllowedEmailDomains || "",
          allowedDeviceIds: data.flows.allowedDeviceIds || data.flows.AllowedDeviceIds || "",
          geoFenceJson: data.flows.geoFenceJson || data.flows.GeoFenceJson || null,
          endQuestionForm: data.flows.endQuestionForm ?? data.flows.EndQuestionForm ?? null,
        };
        localStorage.setItem("flow", JSON.stringify(data.flows));
        localStorage.setItem(
          "flowCoverPageDetails",
          JSON.stringify(coverWithAccess)
        );
        localStorage.setItem(
          "stepsCoverPageDetails",
          JSON.stringify(data.flows.steps)
        );
        localStorage.setItem(
          "ItemsRequired",
          JSON.stringify(data.flows.components)
        );
        localStorage.setItem("draftWord", "Draft Flow");
       this.router.navigate(["/create-guide"],{
        queryParams: {
        returnUrl: this.router.url
        }
      }
    );
      } else {
      }
    });
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
    this.router.navigate(["/"]);
  }

  follower() {
    this.router.navigate(["/followers"]);
  }

  following() {
    this.router.navigate(["/followers"]);
  }

  avatarClicked(notification: any, source: any) {
    const contentType = (
      notification.contentType ||
      notification.ContentType ||
      ""
    ).toString();
    if (source == "flow clicked") {
      if (contentType === "Flow") {
        localStorage.setItem("notificationflowId", notification.rowKey);
        localStorage.setItem("flow", null);
        this.router.navigate([
          `/guide/${this.generateUrlSlug(notification.contentTitle)}/${
            notification.contentId
          }`,
        ]);
      } else if (contentType === "Bundle") {
        this.router.navigate(["/view-guide-pack/" + notification.rowKey]);
      } else if (contentType === "Consult") {
        const email =
          this.userData?.emailAddress || this.userData?.EmailAddress;
        this.router.navigate([
          getConsultationDashboardPath(notification, email),
        ]);
      }
    } else if (source == "profile clicked") {
      if (this.userData.emailAddress === notification.notifierUserEmail) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }

      this.dataService.flowByCategorieschangeMessage(notification);
    }
  }

  search() {
    if (this.searchInput && this.searchInput.trim() !== "") {
      this.ensureActiveTabCacheHydrated();
      this.isSearchActive = true;
      this.performProfileSearch();
    } else {
      // Clear search and restore existing tab data (no API call)
      this.isSearchActive = false;
      this.searchResults = [];
      this.restoreActiveTabDataFromCache();
    }
  }

  onSearchInputChange(): void {
    this.search();
  }

  /** Clear input and reset tab content (matches main header search clear behavior). */
  clearProfileMobileSearchInput(): void {
    this.searchInput = "";
    this.search();
  }

  performProfileSearch() {
    const searchTerm = this.searchInput.trim();
    if (!searchTerm) {
      return;
    }

    // Search only in the already loaded data for the selected tab (no API call)
    const tabId = this.getActiveTabId();
    if (tabId === "guides") {
      this.tempFlows = this.filterBySearchTerm(this.allTempFlows, searchTerm);
      this.isthereAnyFlows = this.tempFlows.length > 0;
    } else if (tabId === "guidePacks") {
      this.tempBundles = this.filterBySearchTerm(this.allTempBundles, searchTerm);
      this.isthereAnyBundles = this.tempBundles.length > 0;
    } else if (tabId === "draft") {
      this.itistempFlows = this.filterBySearchTerm(
        this.allDraftTempFlows,
        searchTerm
      );
      this.isthereAnyDraftFlows = this.itistempFlows.length > 0;
    } else if (tabId === "saved") {
      this.istempFlows = this.filterBySearchTerm(
        this.allSavedTempFlows,
        searchTerm
      );
      this.isthereAnySavedFlows = this.istempFlows.length > 0;
    } else if (tabId === "purchased") {
      this.istempFlows = this.filterBySearchTerm(
        this.allPurchasedTempFlows,
        searchTerm
      );
      this.isthereAnyPurchasedFlows = this.istempFlows.length > 0;
    } else if (tabId === "builds") {
      this.userBuilds = this.filterBySearchTerm(this.allUserBuilds, searchTerm);
      this.isthereAnyBuilds = this.userBuilds.length > 0;
    } else if (tabId === "applications") {
      this.profileApplications = this.filterBySearchTerm(
        this.orgContextService.snapshot.applications || [],
        searchTerm
      );
    } else if (tabId === "teams") {
      this.refreshProfileTeams();
      this.profileTeams = this.filterBySearchTerm(this.profileTeams, searchTerm);
    }
    this.ref.detectChanges();
  }

  private filterBySearchTerm(items: any[], searchTerm: string): any[] {
    const normalizedSearchTerm = searchTerm.toLowerCase();
    return (items || []).filter((item: any) => {
      const title = (item?.title || item?.flowTitle || item?.name || "").toLowerCase();
      const description = (item?.description || "").toLowerCase();
      const uniqueId = (item?.uniqueId || item?.applicationId || item?.teamId || "").toLowerCase();
      const admin = (
        item?.adminEmail ||
        item?.adminDisplayName ||
        item?.applicationName ||
        ""
      ).toLowerCase();
      return (
        title.includes(normalizedSearchTerm) ||
        description.includes(normalizedSearchTerm) ||
        uniqueId.includes(normalizedSearchTerm) ||
        admin.includes(normalizedSearchTerm)
      );
    });
  }

  private ensureActiveTabCacheHydrated(): void {
    const tabId = this.getActiveTabId();
    if (tabId === "guides" && this.allTempFlows.length === 0 && this.tempFlows?.length) {
      this.allTempFlows = [...this.tempFlows];
    } else if (
      tabId === "guidePacks" &&
      this.allTempBundles.length === 0 &&
      this.tempBundles?.length
    ) {
      this.allTempBundles = [...this.tempBundles];
    } else if (
      tabId === "draft" &&
      this.allDraftTempFlows.length === 0 &&
      this.itistempFlows?.length
    ) {
      this.allDraftTempFlows = [...this.itistempFlows];
    } else if (
      tabId === "saved" &&
      this.allSavedTempFlows.length === 0 &&
      this.istempFlows?.length
    ) {
      this.allSavedTempFlows = [...this.istempFlows];
    } else if (
      tabId === "purchased" &&
      this.allPurchasedTempFlows.length === 0 &&
      this.istempFlows?.length
    ) {
      this.allPurchasedTempFlows = [...this.istempFlows];
    } else if (
      tabId === "builds" &&
      this.allUserBuilds.length === 0 &&
      this.userBuilds?.length
    ) {
      this.allUserBuilds = [...this.userBuilds];
    }
  }

  private restoreActiveTabDataFromCache(): void {
    const tabId = this.getActiveTabId();
    if (tabId === "guides") {
      this.tempFlows = [...this.allTempFlows];
      this.isthereAnyFlows = this.tempFlows.length > 0;
    } else if (tabId === "guidePacks") {
      this.tempBundles = [...this.allTempBundles];
      this.isthereAnyBundles = this.tempBundles.length > 0;
    } else if (tabId === "draft") {
      this.itistempFlows = [...this.allDraftTempFlows];
      this.isthereAnyDraftFlows = this.itistempFlows.length > 0;
    } else if (tabId === "saved") {
      this.istempFlows = [...this.allSavedTempFlows];
      this.isthereAnySavedFlows = this.istempFlows.length > 0;
    } else if (tabId === "purchased") {
      this.istempFlows = [...this.allPurchasedTempFlows];
      this.isthereAnyPurchasedFlows = this.istempFlows.length > 0;
    } else if (tabId === "builds") {
      this.userBuilds = [...this.allUserBuilds];
      this.isthereAnyBuilds = this.userBuilds.length > 0;
    } else if (tabId === "applications") {
      this.profileApplications =
        this.orgContextService.snapshot.applications || [];
    } else if (tabId === "teams") {
      this.refreshProfileTeams();
    }
    this.ref.detectChanges();
  }

  loadTabContent() {
    this.loadTabContentForId(this.getActiveTabId(), true);
  }

  private loadTabContentForId(tabId: ProfileTabId, forceReload: boolean): void {
    if (forceReload) {
      if (tabId === "guides") this.hasLoadedApproved = false;
      else if (tabId === "guidePacks") this.hasLoadedBundles = false;
      else if (tabId === "draft") this.hasLoadedDraft = false;
      else if (tabId === "saved") this.hasLoadedSaved = false;
      else if (tabId === "purchased") this.hasLoadedPurchased = false;
      else if (tabId === "builds") this.hasLoadedBuilds = false;
    }

    if (tabId === "guides") {
      if (!this.showCreatorLibraryTabs) return;
      this.getApprovedFlows();
    } else if (tabId === "guidePacks") {
      if (!this.showCreatorLibraryTabs) return;
      this.getBundles(false);
    } else if (tabId === "draft") {
      if (!this.showCreatorLibraryTabs) return;
      this.getDraftFlows(false);
    } else if (tabId === "saved") {
      this.getSavedFlows(false);
    } else if (tabId === "purchased") {
      if (!this.showCreatorLibraryTabs) return;
      this.getPurchasedFlows(false);
    } else if (tabId === "builds") {
      if (!this.showCreatorLibraryTabs) return;
      this.getUserBuilds(false);
    } else if (tabId === "applications" || tabId === "teams") {
      this.refreshProfileTeams();
      this.profileApplications =
        this.orgContextService.snapshot.applications || [];
      this.isInitialContentLoading = false;
      this.isInitialDataLoading = false;
    }
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
    if (!this.isSearchOpen) {
      this.searchInput = "";
      this.isSearchActive = false;
      this.searchResults = [];
      this.restoreActiveTabDataFromCache();
    }
  }

  getPurchasedFlows(arg0: boolean): void {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    // Only show initial skeleton the first time
    if (this.hasLoadedPurchased) {
      return;
    }
    this.isInitialDataLoading = true;
    this.noPurchasedFlows = true;
    this.isthereAnyPurchasedFlows = true;
    this.noMorePurchasedFlows = false;
    this.purchasedFlows = [];
    this.istempFlows = [];
    this.allPurchasedTempFlows = [];
    localStorage.removeItem("purchasePageIndex");
    localStorage.setItem("purchasePageIndex", "0");
    this.callPurchasedFlowService("0");
  }

  getApprovedFlows(): void {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    // Only show initial skeleton the first time
    if (this.hasLoadedApproved) {
      return;
    }
    this.isInitialDataLoading = true;
    this.noApprovedFlows = true;
    this.isthereAnyFlows = true;
    this.noMoreApprovedFlows = false;
    this.approvedFlows = [];
    this.tempFlows = [];
    this.allTempFlows = [];
    this.approvedScopeSkipPages = 0;
    localStorage.removeItem("approvedPageIndex");
    localStorage.setItem("approvedPageIndex", "0");
    this.callServiceForApprovedFlows(0);
  }

  getDraftFlows(isCalledFromNgInit) {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    if (this.hasLoadedDraft) {
      return;
    }
    this.isInitialDataLoading = true;
    this.isthereAnyDraftFlows = true;
    this.noDraftFlows = true;
    this.noMoreDraftFlows = false;
    this.draftFlows = [];
    this.itistempFlows = [];
    this.allDraftTempFlows = [];
    this.draftScopeSkipPages = 0;
    this.tabIndex = localStorage.getItem("draftTabIndex");
    if (this.getActiveTabId() === "draft" || this.tabIndex == "2") {
      localStorage.removeItem("draftTabIndex");
    }
    localStorage.removeItem("draftPageIndex");
    localStorage.setItem("draftPageIndex", "0");
    this.callDraftFlowService(0);
  }

  getSavedFlows(isCalledFromNgInit): void {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    if (this.hasLoadedSaved) {
      return;
    }
    this.isInitialDataLoading = true;
    this.noSavedFlows = true;
    this.noMoreSavedFlows = false;
    this.savedFlows = [];
    this.istempFlows = [];
    this.allSavedTempFlows = [];
    localStorage.removeItem("savePageIndex");
    localStorage.setItem("savePageIndex", "0");
    this.callSaveFlowService(0);
  }

  getBundles(isCalledFromNgInit) {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    if (this.hasLoadedBundles) {
      return;
    }
    this.isInitialDataLoading = true;
    this.isthereAnyBundles = true;
    this.noBundles = true;
    this.noMoreBundles = false;
    this.bundles = [];
    this.tempBundles = [];
    this.allTempBundles = [];
    this.bundleScopeSkipPages = 0;
    localStorage.removeItem("bundlePageIndex");
    localStorage.setItem("bundlePageIndex", "0");
    this.callBundleFlowService(0);
  }

  ngOnDestroy() {
    this.scrollSubject.unsubscribe();
    if (this.orgContextSub) {
      this.orgContextSub.unsubscribe();
      this.orgContextSub = null;
    }
  }

  performScroll(event) {
    if (this.isLoadingMore) {
      return;
    }

    const tabId = this.getActiveTabId();

    // Set isLoadingMore AFTER the guard so it accurately reflects an in-flight API call.
    // onScrollOn no longer sets it, so this is the only place it becomes true.
    if (tabId === "guides") {
      if (this.noMoreApprovedFlows) return;
      this.isLoadingMore = true;
      this.handleTabScroll("approvedPageIndex");
      var pageIndex = localStorage.getItem("approvedPageIndex");
      this.callServiceForApprovedFlows(
        isNaN(parseInt(pageIndex)) ? 0 : parseInt(pageIndex, 10)
      );
    }

    if (tabId === "guidePacks") {
      if (this.noMoreBundles) return;
      this.isLoadingMore = true;
      this.handleTabScroll("bundlePageIndex");
      var pageIndex = localStorage.getItem("bundlePageIndex");
      this.callBundleFlowService(
        isNaN(parseInt(pageIndex)) ? 0 : parseInt(pageIndex, 10)
      );
    }

    if (tabId === "draft") {
      if (this.noMoreDraftFlows) return;
      this.isLoadingMore = true;
      this.handleTabScroll("draftPageIndex");
      var pageIndex = localStorage.getItem("draftPageIndex");
      this.callDraftFlowService(
        isNaN(parseInt(pageIndex)) ? 0 : parseInt(pageIndex, 10)
      );
    }

    if (tabId === "saved") {
      if (this.noMoreSavedFlows) return;
      this.isLoadingMore = true;
      this.handleTabScroll("savePageIndex");
      var pageIndex = localStorage.getItem("savePageIndex");
      this.callSaveFlowService(
        isNaN(parseInt(pageIndex)) ? 0 : parseInt(pageIndex, 10)
      );
    }

    if (tabId === "purchased") {
      if (this.noMorePurchasedFlows) return;
      this.isLoadingMore = true;
      this.handleTabScroll("purchasePageIndex");
      var pageIndex = localStorage.getItem("purchasePageIndex");
      this.callPurchasedFlowService(
        isNaN(parseInt(pageIndex)) ? 0 : parseInt(pageIndex, 10)
      );
    }
  }

  private scrollSubject = new Subject<MouseEvent>();
  handleTabScroll(pageIndexKey) {
    const stored = localStorage.getItem(pageIndexKey);
    const currentIndex = isNaN(parseInt(stored)) ? 0 : parseInt(stored, 10);
    const nextIndex = currentIndex + 1;
    localStorage.setItem(pageIndexKey, nextIndex.toString());
  }

  private refreshProfileDataForCurrentRoute(): void {
    // Reload user data from local storage (it might have changed)
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    if (!this.userData) {
      return;
    }

    this.rebuildVisibleTabs();
    this.resetLoadedTabFlags();

    this.isInitialDataLoading = true;
    this.isInitialContentLoading = true;

    // Always refresh profile header data
    this.getProfileUser();

    // Reload the currently active tab's data (flows, bundles, etc.)
    this.loadTabContent();
  }

  private setupNavigationRefresh(): void {
    if (this.hasInitializedNavigationRefresh) {
      return;
    }

    this.hasInitializedNavigationRefresh = true;

    // Skip the NavigationEnd that corresponds to the initial entry — ngOnInit
    // already loads profile data. Re-running both freezes /user-profile.
    let skipInitialNavEnd = true;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // When navigating to /user-profile, ensure APIs are called to get flows, bundles, etc.
        if ((event as NavigationEnd).urlAfterRedirects?.startsWith("/user-profile")) {
          if (skipInitialNavEnd) {
            skipInitialNavEnd = false;
            return;
          }
          this.refreshProfileDataForCurrentRoute();
        }
      });
  }

  onScrollOn(event: MouseEvent) {
    this.isInitialContentLoading = false;
    this.scrollSubject.next(event);
  }

  /** Keep activeTabIndex aligned with mat-tab-group selected index (binding + user taps). */
  private syncActiveTabIndexFromTabBinding(): void {
    const raw = this.tabIndex;
    const n =
      typeof raw === "string"
        ? parseInt(raw, 10)
        : typeof raw === "number"
          ? raw
          : 0;
    if (!isNaN(n) && n >= 0 && n < this.visibleTabIds.length) {
      this.activeTabIndex = n;
    } else {
      this.activeTabIndex = 0;
    }
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    // Ignore tab churn while org-context is rebuilding visible tabs.
    if (this.orgContextHandling) {
      this.activeTabIndex = tabChangeEvent.index;
      this.tabIndex = String(tabChangeEvent.index);
      return;
    }

    this.tabIndex = String(tabChangeEvent.index);

    // Save current scroll position before switching tabs
    const scrollContainer = document.querySelector('.gridgroup-wrap');
    if (scrollContainer && this.activeTabIndex !== undefined) {
      this.tabScrollPositions[this.activeTabIndex] = scrollContainer.scrollTop;
    }
    
    this.activeTabIndex = tabChangeEvent.index;
    const tabId = this.getActiveTabId();

    // If search is active, perform search in the new tab
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      this.performProfileSearch();
    } else {
      // Determine whether the newly active tab needs a data fetch
      const needsLoad =
        (tabId === "guides" && !this.hasLoadedApproved) ||
        (tabId === "guidePacks" && !this.hasLoadedBundles) ||
        (tabId === "draft" && !this.hasLoadedDraft) ||
        (tabId === "saved" && !this.hasLoadedSaved) ||
        (tabId === "purchased" && !this.hasLoadedPurchased) ||
        (tabId === "builds" && !this.hasLoadedBuilds);

      // If the tab is already loaded, dismiss any lingering skeleton immediately
      if (!needsLoad) {
        this.isInitialContentLoading = false;
        this.isInitialDataLoading = false;
      }

      this.loadTabContentForId(tabId, false);
    }
    
    // Restore scroll position for the new tab after DOM is updated
    // Use requestAnimationFrame to ensure DOM has been updated
    requestAnimationFrame(() => {
      setTimeout(() => {
        const scrollContainer = document.querySelector('.gridgroup-wrap');
        if (scrollContainer) {
          if (this.tabScrollPositions[tabChangeEvent.index] !== undefined) {
            scrollContainer.scrollTop = this.tabScrollPositions[tabChangeEvent.index];
          }
          // Prevent any automatic scroll to top by ensuring we maintain current position
        }
      }, 0);
    });
  }

  viewUserProfile(selectedFlow) {
    if (this.userData != null) {
      if (this.userData.emailAddress === selectedFlow.customerEmail) {
        this.router.navigate(["/user-profile"]);
      } else if (selectedFlow.userName) {
        this.router.navigate(["/view-profile", selectedFlow.userName.replace(/^@/, '')]);
      } else {
        this.dataService.flowByCategorieschangeMessage(selectedFlow);
        this.router.navigate(["/view-profile"]);
      }
    } else {
      // Open login modal instead of navigating to page
      this.authModalService.openModal('login', this.router.url);
    }
  }

  viewCoAuthorProfile(item: any, event: Event): void {
    event.stopPropagation();
    if (!item.coAuthorEmail) return;
    if (this.userData?.emailAddress === item.coAuthorEmail) {
      this.router.navigate(['/user-profile']);
    } else if (item.coAuthorUserName) {
      this.router.navigate(['/view-profile', item.coAuthorUserName.replace(/^@/, '')]);
    } else {
      this.dataService.flowByCategorieschangeMessage({ customerEmail: item.coAuthorEmail });
      this.router.navigate(['/view-profile']);
    }
  }

  /** Item whose collab popup is currently open (null = closed). */
  collabPopupItem: any = null;
  /** Pre-computed co-authors for the open popup (avoids template function calls on every CD cycle). */
  collabPopupCoAuthors: { email: string; userName: string; profilePicUrl: string }[] = [];

  showCollabPopup(item: any, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = this.collabPopupItem === item ? null : item;
    this.collabPopupCoAuthors = this.collabPopupItem ? this.getCollabCoAuthors(this.collabPopupItem) : [];
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.collabPopupItem = null;
  }

  navigateToUserFromPopup(item: any, isCoAuthor: boolean, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    if (isCoAuthor) {
      this.viewCoAuthorProfile(item, event);
    } else {
      this.viewUserProfile(item);
    }
  }

  /** Returns true when the flow item is a collaboration (handles both API casing conventions). */
  isCollabFlow(item: any): boolean {
    if (!(item?.isCollaboration || item?.IsCollaboration)) return false;
    if (!(item?.coAuthorEmail || item?.CoAuthorEmail)) return false;
    // Check per-person statuses first (array wins over single status)
    const statusesRaw = item?.coAuthorStatuses || item?.CoAuthorStatuses || null;
    if (statusesRaw) {
      try {
        const statuses: string[] = JSON.parse(statusesRaw);
        return statuses.some(s => s === 'Accepted');
      } catch {}
    }
    // Fall back to single collaborationStatus field
    const status = item?.collaborationStatus || item?.CollaborationStatus || '';
    return status === 'Accepted';
  }

  /** Returns the first accepted co-author's username for the "and @username" text on flow cards. */
  coAuthorDisplay(item: any): string {
    const accepted = this.getCollabCoAuthors(item);
    return accepted.length > 0 ? accepted[0].userName : '';
  }

  getCollabCoAuthors(item: any): { email: string; userName: string; profilePicUrl: string }[] {
    if (!item) return [];
    const coAuthorEmail     = item.coAuthorEmail    || item.CoAuthorEmail    || null;
    const coAuthorUserName  = item.coAuthorUserName || item.CoAuthorUserName || null;
    const coAuthorPicUrl    = item.coAuthorProfilePicUrl || item.CoAuthorProfilePicUrl || null;
    const coAuthorEmails    = item.coAuthorEmails    || item.CoAuthorEmails    || null;
    const coAuthorUserNames = item.coAuthorUserNames || item.CoAuthorUserNames || null;
    const coAuthorPicUrls   = item.coAuthorProfilePicUrls || item.CoAuthorProfilePicUrls || null;
    const coAuthorStatuses  = item.coAuthorStatuses  || item.CoAuthorStatuses  || null;
    let emails: string[] = [];
    let userNames: string[] = [];
    let profilePicUrls: string[] = [];
    let statuses: string[] = [];
    try { if (coAuthorEmails) emails = JSON.parse(coAuthorEmails); } catch {}
    try { if (coAuthorUserNames) userNames = JSON.parse(coAuthorUserNames); } catch {}
    try { if (coAuthorPicUrls) profilePicUrls = JSON.parse(coAuthorPicUrls); } catch {}
    try { if (coAuthorStatuses) statuses = JSON.parse(coAuthorStatuses); } catch {}
    const singleStatus = item?.collaborationStatus || item?.CollaborationStatus || '';
    if (Array.isArray(emails) && emails.length > 0) {
      return emails
        .map((email, i) => ({
          email,
          userName: userNames[i] || (i === 0 ? coAuthorUserName : '') || email,
          profilePicUrl: profilePicUrls[i] || (i === 0 ? coAuthorPicUrl : '') || '',
          // CoAuthorStatuses is not persisted by the backend; fall back to the flow's
          // CollaborationStatus for every slot so all accepted co-authors are visible.
          status: statuses[i] || singleStatus,
        }))
        .filter(c => c.status === 'Accepted');
    }
    if (coAuthorEmail && singleStatus === 'Accepted') {
      return [{ email: coAuthorEmail, userName: coAuthorUserName || coAuthorEmail, profilePicUrl: coAuthorPicUrl || '' }];
    }
    return [];
  }

  getExtraCollabCount(item: any): number {
    return Math.max(0, this.getCollabCoAuthors(item).length - 1);
  }

  navigateToCoAuthorProfile(coAuthor: { email: string; userName: string; profilePicUrl: string }, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    const syntheticItem = { coAuthorEmail: coAuthor.email, coAuthorUserName: coAuthor.userName };
    this.viewCoAuthorProfile(syntheticItem, event);
  }

  showImage(itemCategory, item, index) {
    itemCategory.flowModels.forEach((element) => {
      if (element.arrow !== undefined) {
        element.arrow = false;
      }
    });
    if (!itemCategory.showImg || index !== this.previousIndex) {
      this.currentImage = item.Url;
      this.previousIndex = index;
      itemCategory.showImg = true;
      item.arrow = true;
    } else {
      itemCategory.showImg = false;
      item.arrow = false;
    }
  }

  getFlows() {
    this.approvedFlows = [];
    this.flows = [];
    this.getApprovedFlows();
  }

  draft() {
    this.draftFlows = [];
    this.itistempFlows = [];
    this.flows = [];
    this.getDraftFlows(false);
  }

  saved() {
    this.savedFlows = [];
    this.flows = [];
    this.getSavedFlows(false);
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.resize(event);
  }

  resize(event) {
    if (event.srcElement.outerWidth <= 1200) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }

  onResize(event) {
    this.resize(event);
  }

  callServiceForApprovedFlows(pageIndex) {
    const flowQueryModel = this.flowQueryService.createFlowQueryModel(
      "",
      "",
      "",
      pageIndex,
      "",
      ""
    );

    this.flowServiceService
      .getApprovedFlows(flowQueryModel)
      .subscribe({
        next: (data) => {
          if (data.flows.length > 0) {
            this.isthereAnyFlows = true;

            const existingKeys = new Set(this.tempFlows.map((f) => f.rowKey));
            data.flows.forEach((element) => {
              if (
                !existingKeys.has(element.rowKey) &&
                this.itemMatchesAccountScope(element)
              ) {
                this.tempFlows.push(element);
              }
            });
            this.allTempFlows = [...this.tempFlows];
            this.approvedFlowslength = this.tempFlows.length;
            this.approvedFlows = [];
            this.flows = this.tempFlows;
            this.isthereAnyFlows = this.tempFlows.length > 0;
            this.noApprovedFlows = this.tempFlows.length > 0;

            if (data.flows.length < this.PAGE_SIZE) {
              this.noMoreApprovedFlows = true;
            } else if (
              this.tempFlows.length === 0 &&
              this.approvedScopeSkipPages < this.MAX_SCOPE_SKIP_PAGES
            ) {
              // Full page was out-of-scope (e.g. public guides while in org mode) — keep looking.
              this.approvedScopeSkipPages++;
              this.callServiceForApprovedFlows(Number(pageIndex) + 1);
              return;
            }
            if (this.noMoreApprovedFlows && this.tempFlows.length === 0) {
              this.isthereAnyFlows = false;
              this.approvedFlows = [
                { Title: "You don't have any guides for this account type" },
              ];
              this.noApprovedFlows = false;
            }
          } else {
            this.noMoreApprovedFlows = true;
            if (this.tempFlows.length == 0) {
              this.isthereAnyFlows = false;
              var flow = { Title: "You don't have any saved flows" };
              this.approvedFlows.push(flow);
              this.noApprovedFlows = false;
            }
          }
          this.isLoadingMore = false;
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.hasLoadedApproved = true;
          this.scheduleRetranslate();
        },
        error: () => {
          this.isLoadingMore = false;
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isthereAnyFlows = false;
          this.noMoreApprovedFlows = true;
          this.hasLoadedApproved = true;
        }
      });
  }

  private scheduleRetranslate(): void {
    if (this.translationService.getCurrentTranslationLanguage()) {
      setTimeout(() => this.translationService.retranslateForNewContent(), 200);
    }
  }

  getProfileUser(): void {
    this.showNotificationCount = true;
    this.userserviceService.getProfileUser().subscribe((data) => {
      if (
        data.userData.profilePicUrl === "" ||
        data.userData.profilePicUrl == null
      ) {
        this.showDefaultImage = true;
      } else {
        this.showDefaultImage = false;
        this.profilePicture = data.userData.profilePicUrl;
      }
      this.email = data.userData.emailAddress;
      this.phone = data.userData.phoneNumber;
      this.info = data.userData.info;
      this.website = data.userData.website;
      this.userDisplayName = this.uname = data.userData.userName;
      this.name = data.userData.firstName;

      this.ShowAboutYou = data.userData.showAboutYou;
      this.ShowEmail = data.userData.showEmail;
      this.ShowName = data.userData.showName;
      this.ShowWebsite = data.userData.showWebsite;
      this.ShowPhone = data.userData.showPhone;

      this.GiftedFund = data.userData.giftedFund;
      this.FollowingCount = data.userData.followingCount;
      this.FollowersCount = data.userData.followerCount;
      this.refreshPlanLabel({
        ...this.userData,
        ...data.userData,
      });

      this.isInitialProfileDataLoading = false;
      if (this.openPlanUsageOnLoad && this.showPlanLabel) {
        this.openPlanUsageOnLoad = false;
        this.openSubscriptionUsageDialog();
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { showPlan: null },
          queryParamsHandling: "merge",
          replaceUrl: true,
        });
      }
    });
    this.loadScopedContentCounts();
    this.getUserBlogs();
  }

  /** Tab badge counts for the active account type only (public or the active organization). */
  private loadScopedContentCounts(): void {
    const requestId = ++this.contentCountsRequestId;
    this.userserviceService
      .getProfileContentCounts(this.getActiveOrgScopeId())
      .subscribe({
        next: (counts) => {
          if (requestId !== this.contentCountsRequestId) return;
          this.FlowCount = counts?.flowCount ?? 0;
          this.Bundlecount = counts?.bundleCount ?? 0;
          this.Draftcount = counts?.draftCount ?? 0;
          this.Savedcount = counts?.savedCount ?? 0;
          this.Purchasedcount = counts?.purchasedCount ?? 0;
        },
        error: () => {
          if (requestId !== this.contentCountsRequestId) return;
          this.FlowCount = 0;
          this.Bundlecount = 0;
          this.Draftcount = 0;
          this.Savedcount = 0;
          this.Purchasedcount = 0;
        },
      });
  }

  private refreshPlanLabel(user?: any): void {
    const assignedPlan = getAssignedPlanId(user || this.userData);
    this.planId = assignedPlan || "";
    this.showPlanLabel = hasAssignedContentPlan(user || this.userData);
    this.planDisplayName = assignedPlan
      ? this.getPlanDisplayName(assignedPlan)
      : "";
  }

  private getPlanDisplayName(planId: string): string {
    switch ((planId || "").toLowerCase()) {
      case "creator":
        return "Creator";
      case "starter":
        return "Starter";
      case "growth":
        return "Growth";
      case "enterprise":
        return "Enterprise";
      default:
        return "";
    }
  }

  /** Suffix for the plan chip while the Starter free trial runs, e.g. "Trial, 6d left". */
  get planTrialLabel(): string {
    if (this.planId !== "starter" || !isTrialActive()) {
      return "";
    }
    return `Trial, ${getTrialDaysLeft()}d left`;
  }

  openSubscriptionUsageDialog(): void {
    if (!this.userData || !this.showPlanLabel || !this.isPublicAccountMode) {
      return;
    }
    const dialogRef = this.dialog.open(SubscriptionUsageDialogComponent, {
      width: "600px",
      height: "600px",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "subscription-usage-dialog-pane",
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.trialCancelled) {
        this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
        this.refreshPlanLabel(this.userData);
      }
    });
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      localStorage.removeItem("ItemsRequired");
      localStorage.removeItem("flowCoverPageDetails");
      localStorage.removeItem("stepsCoverPageDetails");
      localStorage.removeItem("draftWord");
      localStorage.removeItem("editWord");
      localStorage.setItem("navigatebackfromcreateflow", this.location.path());
      localStorage.setItem(
        "navigatebackfromcreatebundle",
        this.location.path()
      );
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
    this.getnotification();
  }

  callDraftFlowService(pageIndex) {
    const flowQueryModel = this.flowQueryService.createFlowQueryModel(
      "",
      "",
      this.userData.emailAddress.toLowerCase(),
      pageIndex,
      "",
      ""
    );

    this.flowServiceService.getDraftFlows(flowQueryModel).subscribe({
      next: (data) => {
        if (data.flows.length > 0) {
          this.isthereAnyDraftFlows = true;
          const existingKeys = new Set(this.itistempFlows.map((f) => f.rowKey));
          data.flows.forEach((element) => {
            if (
              !existingKeys.has(element.rowKey) &&
              this.itemMatchesAccountScope(element)
            ) {
              this.itistempFlows.push(element);
            }
          });
          this.allDraftTempFlows = [...this.itistempFlows];
          this.draftFlows = this.itistempFlows;
          this.isthereAnyDraftFlows = this.itistempFlows.length > 0;
          this.noDraftFlows = this.itistempFlows.length > 0;

          if (data.flows.length < this.PAGE_SIZE) {
            this.noMoreDraftFlows = true;
          } else if (
            this.itistempFlows.length === 0 &&
            this.draftScopeSkipPages < this.MAX_SCOPE_SKIP_PAGES
          ) {
            this.draftScopeSkipPages++;
            this.callDraftFlowService(Number(pageIndex) + 1);
            return;
          }
          if (this.noMoreDraftFlows && this.itistempFlows.length === 0) {
            this.isthereAnyDraftFlows = false;
            this.draftFlows = [
              { Title: "You don't have any drafts for this account type" },
            ];
            this.noDraftFlows = false;
          }
        } else {
          this.noMoreDraftFlows = true;
          if (this.itistempFlows.length == 0) {
            this.isthereAnyDraftFlows = false;
            var flow = { Title: "You don't have any saved flows" };
            this.draftFlows.push(flow);
            this.noDraftFlows = false;
          }
        }
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.hasLoadedDraft = true;
        this.scheduleRetranslate();
      },
      error: () => {
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.isthereAnyDraftFlows = false;
        this.noMoreDraftFlows = true;
        this.hasLoadedDraft = true;
      }
    });
  }

  noflow: boolean;

  callPurchasedFlowService(pageIndex) {
    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: pageIndex,
    });
    this.flowServiceService
      .getPurchasedFlows(flowQueryModel)
      .subscribe({
        next: (data) => {
          if (data.flows.length > 0) {
            this.isthereAnyPurchasedFlows = true;
            const existingKeys = new Set(this.istempFlows.map((f) => f.rowKey));
            data.flows.forEach((element) => {
              if (
                element.price &&
                !existingKeys.has(element.rowKey) &&
                this.itemMatchesAccountScope(element)
              ) {
                this.istempFlows.push(element);
              }
            });
            this.allPurchasedTempFlows = [...this.istempFlows];
            this.purchasedFlows = this.istempFlows;

            if (data.flows.length < this.PAGE_SIZE) {
              this.noMorePurchasedFlows = true;
            }
          } else {
            this.noMorePurchasedFlows = true;
            if (this.istempFlows.length == 0) {
              this.isthereAnyPurchasedFlows = false;
              var flow = { Title: "You don't have any purchased flows" };
              this.purchasedFlows.push(flow);
              this.noPurchasedFlows = false;
            }
          }
          this.isLoadingMore = false;
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.hasLoadedPurchased = true;
          this.scheduleRetranslate();
        },
        error: () => {
          this.isLoadingMore = false;
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isthereAnyPurchasedFlows = false;
          this.noMorePurchasedFlows = true;
          this.hasLoadedPurchased = true;
        }
      });
  }

  callSaveFlowService(pageIndex) {
    const flowQueryModel = this.flowQueryService.createFlowQueryModel(
      "",
      "",
      this.userData.emailAddress,
      pageIndex,
      "",
      ""
    );

    this.flowServiceService.getSavedFlows(flowQueryModel).subscribe({
      next: (data) => {
        if (data.flows.length > 0) {
          this.isthereAnySavedFlows = true;
          const existingKeys = new Set(this.istempFlows.map((f) => f.rowKey));
          data.flows.forEach((element) => {
            if (
              !existingKeys.has(element.rowKey) &&
              this.itemMatchesAccountScope(element)
            ) {
              this.istempFlows.push(element);
            }
          });
          this.allSavedTempFlows = [...this.istempFlows];
          this.savedFlows = this.istempFlows;
          this.isthereAnySavedFlows = this.istempFlows.length > 0;
          this.noSavedFlows = this.istempFlows.length > 0;

          if (data.flows.length < this.PAGE_SIZE) {
            this.noMoreSavedFlows = true;
          }
          if (this.noMoreSavedFlows && this.istempFlows.length === 0) {
            this.isthereAnySavedFlows = false;
            this.savedFlows = [
              { Title: "You don't have any saved guides for this account type" },
            ];
            this.noSavedFlows = false;
          }
        } else {
          this.noMoreSavedFlows = true;
          if (this.istempFlows.length == 0) {
            this.isthereAnySavedFlows = false;
            var flow = { Title: "You don't have any saved flows" };
            this.savedFlows.push(flow);
            this.noSavedFlows = false;
          }
        }
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.hasLoadedSaved = true;
        this.scheduleRetranslate();
      },
      error: () => {
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.isthereAnySavedFlows = false;
        this.noMoreSavedFlows = true;
        this.hasLoadedSaved = true;
      }
    });
  }

  callBundleFlowService(pageIndex: number) {
    this.noBundles = true;

    const flowQueryModel = this.flowQueryService.createFlowQueryModel(
      "",
      "",
      this.userData.emailAddress,
      pageIndex,
      "",
      ""
    );

    this.flowServiceService.getUserBundles(flowQueryModel).subscribe({
      next: (data) => {
        if (data.bundles.length > 0) {
          this.isthereAnyBundles = true;
          const existingKeys = new Set(this.tempBundles.map((b) => b.rowKey));
          data.bundles.forEach((element) => {
            if (
              !existingKeys.has(element.rowKey) &&
              this.itemMatchesAccountScope(element)
            ) {
              this.tempBundles.push(element);
            }
          });
          this.allTempBundles = [...this.tempBundles];
          this.isthereAnyBundles = this.tempBundles.length > 0;
          this.noBundles = this.tempBundles.length > 0;

          if (data.bundles.length < this.PAGE_SIZE) {
            this.noMoreBundles = true;
          } else if (
            this.tempBundles.length === 0 &&
            this.bundleScopeSkipPages < this.MAX_SCOPE_SKIP_PAGES
          ) {
            this.bundleScopeSkipPages++;
            this.callBundleFlowService(Number(pageIndex) + 1);
            return;
          }
          if (this.noMoreBundles && this.tempBundles.length === 0) {
            this.isthereAnyBundles = false;
            this.tempBundles = [
              { Title: "You don't have any guide packs for this account type" },
            ];
            this.noBundles = false;
          }
        } else {
          this.noMoreBundles = true;
          if (this.tempBundles.length == 0) {
            this.isthereAnyBundles = false;
            var flow = { Title: "You don't have any bundles" };
            this.tempBundles.push(flow);
          }
        }
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.hasLoadedBundles = true;
        this.scheduleRetranslate();
      },
      error: () => {
        this.isLoadingMore = false;
        this.isInitialDataLoading = false;
        this.isInitialContentLoading = false;
        this.isthereAnyBundles = false;
        this.noMoreBundles = true;
        this.hasLoadedBundles = true;
      }
    });
  }

  getnotification() {
    this.notificationsarray = [];
    this.flowServiceService
      .getNotifications(this.userData.EmailAddress)
      .subscribe((data) => {
        if (data.userNotifications != null) {
          data.userNotifications.forEach((element) => {
            var notification = {
              notification: {
                ProfilePicUrl: element.profilePicUrl,
                NotifierUserName: element.notifierUserName,
                Message: element.message,
                FlowUrl: element.flowUrl,
                FlowId: element.contentId,
                ContentType: element.contentType,
                ConsultationNavTarget: element.consultationNavTarget,
                ContentId: element.contentId,
                ContentTitle: element.contentTitle,
                NotifierUserEmail: element.notifierUserEmail,
                VideoFlowPosterImageUrl: element.videoFlowPosterImageUrl,
              },
            };
            this.notificationsarray.push(notification);
          });
        }
      });
  }

  followersFollowing(id) {
    localStorage.setItem("tabIndex", id);
    this.router.navigate(["/followers"], id);
  }

  openDialog() {
    if (this.userData != null) {
      this.eventEmitterService.setUserProfileCreateIconClickedEvent(
        "add_circle_outline"
      );
      this.add_circle_outlinebgColor = "white";
      this.add_circle_outlineColor = "#5ea1d8 !important";
      this.add_circle_outlineSize = "25px !important";
      localStorage.removeItem("ItemsRequired");
      localStorage.removeItem("flowCoverPageDetails");
      localStorage.removeItem("stepsCoverPageDetails");
      localStorage.removeItem("draftWord");
      localStorage.removeItem("editWord");
      const dialogRef = this.dialog.open(BundledialogComponent, {
        panelClass: "dialoguebox",
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.eventEmitterService.setUserProfileCreateIconClickedEvent(
          "profile"
        );
        if (result === "bundle") {
          localStorage.setItem(
            "navigatebackfromcreatebundle",
            this.location.path()
          );
          localStorage.removeItem("createbundledetails");
          localStorage.removeItem("addbundleselectedflows");
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          this.router.navigate(["/create-guide-pack"]);
        } else if (result === "flow") {
          localStorage.setItem(
            "navigatebackfromcreateflow",
            this.location.path()
          );
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          this.router.navigate(["/create-guide"]);
        } else {
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "profile"
          );
          this.add_circle_outlinebgColor = "white";
          this.add_circle_outlineColor = "#212427 !important";
        }
      });
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  deleteAccount() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.dialog.open(DeleteUserDialogComponent, {
      height: "180px",
      width: "250px",
    });
  }

  getUserBlogs() {
    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
    });
    this.filteredBlogs = [];
    this.flowServiceService
      .getAllUserBlogs(flowQueryModel)
      .subscribe((data) => {
        // Filter only blogs where featureOnProfile is true
        this.filteredBlogs = (data || []).filter(
          (blog) => blog.featureOnProfile === true
        );
      });
  }

  viewAllBlogs() {
    localStorage.setItem("SelectedUserEmail", this.userData.emailAddress);
    this.router.navigateByUrl("/bulbguide");
  }

  viewblog(blog: any) {
    localStorage.setItem("selectedBlogContent", JSON.stringify(blog));
    this.router.navigate(["/blog/" + this.getTitle(blog.title)]);
  }

  getTitle(title: any) {
    // Replace spaces with hyphens and convert to lowercase
    return title.replace(/\s+/g, "-");
  }

  getUserBuilds(arg0: boolean): void {
    // If search is active, don't reload - keep search results
    if (
      this.isSearchActive &&
      this.searchInput &&
      this.searchInput.trim() !== ""
    ) {
      return;
    }
    // Only show initial skeleton the first time
    if (this.hasLoadedBuilds) {
      return;
    }
    this.isInitialDataLoading = true;
    this.isthereAnyBuilds = true;
    this.userBuilds = [];
    this.allUserBuilds = [];
    this.callUserBuildsService();
  }

  callUserBuildsService() {
    if (!this.userData || !this.userData.emailAddress) {
      this.isInitialDataLoading = false;
      this.isInitialContentLoading = false;
      this.isthereAnyBuilds = false;
      return;
    }

    // For user-profile page, we want ALL builds created by the logged-in user
    // Pass empty array to query all reviews across all flows and filter by creatorEmail
    // This will get builds created by the logged-in user on any flow, not just their own flows
    const loggedInUserEmail = this.userData.emailAddress;
    
    // Get user shorts (reviews with media created by the logged-in user)
    // Passing empty array tells the API to scan all partitions and filter by creatorEmail
    this.flowServiceService
      .getUserShorts(loggedInUserEmail, [])
      .subscribe(
        (shortsData) => {
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          
          // Backend filters by creatorEmail, so we can use the results directly
          if (shortsData?.shorts && shortsData.shorts.length > 0) {
            this.isthereAnyBuilds = true;
            this.userBuilds = shortsData.shorts;
            this.allUserBuilds = [...shortsData.shorts];
            this.BuildsCount = shortsData.shorts.length;
          } else {
            this.isthereAnyBuilds = false;
            this.allUserBuilds = [];
            this.BuildsCount = 0;
          }
          this.hasLoadedBuilds = true;
          this.ref.detectChanges();
        },
        (error) => {
          console.error("Error loading builds:", error);
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isthereAnyBuilds = false;
          this.BuildsCount = 0;
          this.hasLoadedBuilds = true;
        }
      );
  }

  getUserReviews(): void {
    if (this.hasLoadedReviews) {
      return; // Already loaded, don't reload
    }

    if (!this.userData || !this.userData.emailAddress) {
      this.isthereAnyReviews = false;
      this.userReviews = [];
      this.ReviewsCount = 0;
      this.noReviews = true;
      this.hasLoadedReviews = true;
      return;
    }

    this.isInitialContentLoading = true;
    const userEmail = this.userData.emailAddress;

    // First, get all flows to extract flowRowKeys
    const flowQueryModel = new FlowQueryModel({
      userEmail: userEmail,
      otherUserEmail: userEmail,
      pageIndex: 0,
      category: "All",
    });

    // Get all flows (approved, draft, etc.) to collect their rowKeys
    this.flowServiceService.getApprovedFlows(flowQueryModel).subscribe({
      next: (flowsData) => {
        const allFlowRowKeys: string[] = [];
        
        // Collect flowRowKeys from approved flows
        if (flowsData && flowsData.flows) {
          flowsData.flows.forEach((flow: any) => {
            if (flow.rowKey) {
              allFlowRowKeys.push(flow.rowKey);
            }
          });
        }

        // Also get draft flows
        this.flowServiceService.getDraftFlows(flowQueryModel).subscribe({
          next: (draftData) => {
            if (draftData && draftData.flows) {
              draftData.flows.forEach((flow: any) => {
                if (flow.rowKey && !allFlowRowKeys.includes(flow.rowKey)) {
                  allFlowRowKeys.push(flow.rowKey);
                }
              });
            }

            // Now get reviews for all these flows using optimized endpoint
            if (allFlowRowKeys.length > 0) {
              // Use the new optimized endpoint that filters by user email on the backend
              this.flowServiceService.getReviewsByUserEmail(userEmail, allFlowRowKeys).subscribe({
                next: (reviewsData) => {
                  this.isInitialContentLoading = false;
                  if (reviewsData && reviewsData.reviews && reviewsData.reviews.length > 0) {
                    this.userReviews = reviewsData.reviews;
                    
                    // Enrich reviews with flow information
                    this.enrichReviewsWithFlowInfo();
                    
                    this.ReviewsCount = this.userReviews.length;
                    this.isthereAnyReviews = this.userReviews.length > 0;
                    this.noReviews = !this.isthereAnyReviews;
                  } else {
                    this.userReviews = [];
                    this.ReviewsCount = 0;
                    this.isthereAnyReviews = false;
                    this.noReviews = true;
                  }
                  this.hasLoadedReviews = true;
                  this.ref.detectChanges();
                },
                error: (error) => {
                  console.error("Error loading user reviews:", error);
                  this.isInitialContentLoading = false;
                  this.userReviews = [];
                  this.ReviewsCount = 0;
                  this.isthereAnyReviews = false;
                  this.noReviews = true;
                  this.hasLoadedReviews = true;
                  this.ref.detectChanges();
                }
              });
            } else {
              // No flows found, so no reviews
              this.isInitialContentLoading = false;
              this.userReviews = [];
              this.ReviewsCount = 0;
              this.isthereAnyReviews = false;
              this.noReviews = true;
              this.hasLoadedReviews = true;
              this.ref.detectChanges();
            }
          },
          error: (error) => {
            console.error("Error loading draft flows for reviews:", error);
            this.isInitialContentLoading = false;
            this.userReviews = [];
            this.ReviewsCount = 0;
            this.isthereAnyReviews = false;
            this.noReviews = true;
            this.hasLoadedReviews = true;
            this.ref.detectChanges();
          }
        });
      },
      error: (error) => {
        console.error("Error loading flows for reviews:", error);
        this.isInitialContentLoading = false;
        this.userReviews = [];
        this.ReviewsCount = 0;
        this.isthereAnyReviews = false;
        this.noReviews = true;
        this.hasLoadedReviews = true;
        this.ref.detectChanges();
      }
    });
  }

  enrichReviewsWithFlowInfo(): void {
    // Get all flows to match with reviews
    const flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      otherUserEmail: this.userData.emailAddress,
      pageIndex: 0,
      category: "All",
    });

    this.flowServiceService.getApprovedFlows(flowQueryModel).subscribe({
      next: (flowsData) => {
        const flowsMap = new Map();
        if (flowsData && flowsData.flows) {
          flowsData.flows.forEach((flow: any) => {
            flowsMap.set(flow.rowKey, flow);
          });
        }

        // Enrich reviews with flow titles
        this.userReviews = this.userReviews.map((review: any) => {
          const flow = flowsMap.get(review.flowRowKey);
          if (flow) {
            review.flowTitle = flow.title;
          }
          return review;
        });

        this.ref.detectChanges();
      }
    });
  }

  getReviewInitials(review: any): string {
    const name = review.createdByUserName || review.createdByFirstName || 'Anonymous';
    if (name === 'Anonymous') return 'A';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  getReviewAvatarColor(review: any): string {
    const colors = [
      '#e0e7ff', '#fce7f3', '#fef3c7', '#d1fae5', '#e0f2fe',
      '#f3e8ff', '#fed7aa', '#fecaca', '#c7d2fe', '#bae6fd'
    ];
    const name = review.createdByUserName || review.createdByFirstName || 'Anonymous';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }

  getReviewTitle(reviewText: string): string {
    if (!reviewText) return '';
    const words = reviewText.split(' ');
    if (words.length <= 5) return reviewText;
    return words.slice(0, 5).join(' ') + '...';
  }
}
